import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  getUserStags,
  checkAuthStatus,
  authStatusSelector,
  checkingAuthStatusSelector,
  registerAuthListener,
  registerOnlineListener,
  registerUserStagsListener,
  networkStatusSelector,
  checkingNetworkStatusSelector,
  newContentAvailableSelector,
  contentCachedSelector,
} from '../../reducers';
import App from './component';
import {
  withRouter
} from 'react-router-dom';

const mapStateToProps = (state) => {
  return {
    authenticated: authStatusSelector(state),
    checkingAuthStatus: checkingAuthStatusSelector(state),
    networkStatus: networkStatusSelector(state),
    checkingNetworkStatus: checkingNetworkStatusSelector(state),
    newContentAvailable: newContentAvailableSelector(state),
    contentCached: contentCachedSelector(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getUserStags,
    checkAuthStatus,
    registerAuthListener,
    registerOnlineListener,
    registerUserStagsListener,
  }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/component/App/index.js